import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShareScreen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShareScreen"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM12 7.18934L16.0607 11.25L15 12.3107L12.75 10.0607V16.5H11.25V10.0607L9 12.3107L7.93934 11.25L12 7.18934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShareScreen;
